// @ts-ignore
import $ from 'jquery';
export const initTypeSelector = (column) => {
    column.getElement().querySelectorAll('select.ac-setting-input_type').forEach(select => {
        $(select).on('change', () => column.switchToType(select.value));
    });
};
